module.exports = __webpack_public_path__ + "img/tile-fnb4.dc6ee072.jpg";